export const mixins = [
  require('./../mixins/register'),
  require('./../mixins/plans'),
  require('./../mixins/vat'),
  require('./../mixins/stripe'),
]
export function data() {
  return {
    query: null,

    cardElement: null,

    coupon: null,
    invalidCoupon: false,

    country: null,
    taxRate: 0,

    registerForm: $.extend(
      true,
      new SparkForm({
        stripe_payment_method: '',
        plan: '',
        team: '',
        team_slug: '',
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        address: '',
        address_line_2: '',
        city: '',
        state: '',
        zip: '',
        country: 'US',
        vat_id: '',
        terms: false,
        coupon: null,
        invitation: null,
        is_gift: null,
        gift_sender_name: '',
        gift_sender_email: '',
        gift_sendout_date: '',
        temp_pwd: '',
      }),
      Spark.forms.register
    ),

    cardForm: new SparkForm({
      name: '',
      number: '',
      cvc: '',
      month: '',
      year: '',
    }),
  }
}
export const watch = {
  /**
   * Watch for changes on the entire billing address.
   */
  currentBillingAddress: function(value) {
    if (!Spark.collectsEuropeanVat) {
      return
    }

    this.refreshTaxRate(this.registerForm)
  },

  /**
   * Watch the team name for changes.
   */
  'registerForm.team': function(val, oldVal) {
    if (
      this.registerForm.team_slug === '' ||
      this.registerForm.team_slug === oldVal.toLowerCase().replace(/[\s\W-]+/g, '-')
    ) {
      this.registerForm.team_slug = val.toLowerCase().replace(/[\s\W-]+/g, '-')
    }
  },

  /**
   * Watch for changes on the selected plan.
   */
  selectedPlan(val) {
    if (!val || val.price === 0) {
      this.cardElement = null
      return
    }

    if (!this.cardElement) {
      this.$nextTick(() => {
        this.cardElement = this.createCardElement('#card-element')
      })
    }
  },
}
export function created() {
  this.getPlans()

  this.guessCountry()

  this.query = URI(document.URL).query(true)

  if (this.query.coupon) {
    this.getCoupon()

    this.registerForm.coupon = this.query.coupon
  }

  if (this.query.invitation) {
    this.getInvitation()

    this.registerForm.invitation = this.query.invitation
  }
  if (this.query.gifting) {
    this.registerForm.is_gift = this.query.gifting
    this.temp_pwd = this.password
  }
}
export const methods = {
  /**
   * Attempt to guess the user's country.
   */
  guessCountry() {
    axios
      .get('/geocode/country')
      .then((response) => {
        if (response.data != 'ZZ' && response.data != '') {
          this.registerForm.country = response.data
        }
      })
      .catch((response) => {
        //
      })
  },

  /**
   * Get the coupon specified in the query string.
   */
  getCoupon() {
    axios
      .get('/coupon/' + this.query.coupon)
      .then((response) => {
        this.coupon = response.data
      })
      .catch((response) => {
        this.invalidCoupon = true
      })
  },

  getRecaptchaToken() {
    return new Promise((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha
          .execute(process.env.MIX_RECAPTCHA_KEY, { action: 'submit' })
          .then(resolve)
          .catch(reject)
      })
    })
  },

  getRecaptchaScore(token) {
    return $.ajax('/recaptcha?response=' + token)
  },

  checkRecaptcha() {
    return this.getRecaptchaToken()
      .then(this.getRecaptchaScore)
      .then((response) => {
        if (response.error) throw new Error(response.error)
        if (response.score < 0.5) throw new Error('Failed recaptcha')
      })
  },

  async getFormCoupon(coupon) {
    if (!coupon) {
      return { valid: false }
    }

    try {
      const response = await axios({
        method: 'GET',
        url: `/coupons/${coupon.trim()}?productId=${
          this.selectedPlan.name == 'Yearly' ? 'prod_KXCreWpzJZqxLZ' : 'prod_KXCqc4thKS0kej'
        }`,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': window.Spark.csrfToken,
        },
      })
        .then((response) => {
          if (response.status !== 200) {
            throw new Error(response.statusText)
          }

          return response
        })
        .then((x) => x.data)

      if (response.error) {
        throw new Error(response.error)
      }

      return response.coupon
    } catch (err) {
      console.error(err)
      if (err.message === 'Failed to look up coupon') {
        throw new Error('Invalid coupon')
      }
      if (['Coupon does not apply to product', 'Coupon is expired', 'Coupon does not exist'].includes(err.message))
        throw err

      throw new Error(
        'Sorry there was a problem checking the provided coupon, please contact support at contact@thebutterbook.com for help'
      )
    }
  },

  /**
   * Attempt to register with the application.
   */
  register() {
    this.checkRecaptcha()
      .then(async () => {
        this.cardForm.errors.forget()

        this.registerForm.busy = true
        this.registerForm.errors.forget()

        try {
          const coupon = await this.getFormCoupon(this.registerForm.coupon)

          if (!coupon.valid) {
            throw new Error('Invalid coupon')
          }
        } catch (err) {
          this.registerForm.errors.set({ coupon: [err.message] })
          this.registerForm.busy = false
          return
        }

        if (!Spark.cardUpFront || this.registerForm.invitation || this.selectedPlan.price === 0) {
          return this.sendRegistration()
        }

        const payload = {
          name: this.cardForm.name,
          address: {
            line1: this.registerForm.address || '',
            line2: this.registerForm.address_line_2 || '',
            city: this.registerForm.city || '',
            state: this.registerForm.state || '',
            postal_code: this.registerForm.zip || '',
            country: this.registerForm.country || '',
          },
        }

        this.generateToken((secret) => {
          const paymentMethodData = {
            payment_method_data: {
              billing_details: payload,
            },
          }
          this.stripe.handleCardSetup(secret, this.cardElement, paymentMethodData).then((response) => {
            if (response.error) {
              this.cardForm.errors.set({ card: [response.error.message] })

              this.registerForm.busy = false
            } else {
              this.sendRegistration(response.setupIntent.payment_method)
            }
          })
        })
      })
      .catch(console.error)
  },

  /*
   * After obtaining the Stripe token, send the registration to Spark.
   */
  sendRegistration(paymentMethod) {
    this.registerForm.stripe_payment_method = paymentMethod

    Spark.post('/register', this.registerForm)
      .then((response) => {
        if (typeof fbq === 'function') {
          fbq('track', 'Purchase', { value: this.selectedPlan.price, currency: 'USD' })
        }
        if (process.env.MIX_GTAG_ID && typeof gtag === 'function') {
          gtag('event', 'conversion', {
            send_to: `${process.env.MIX_GTAG_ID}/qY9oCL7ntcwBEO-G05oD`,
            value: this.selectedPlan.price,
            currency: 'USD',
          })
        }

        window.location = '/questionnaire'
      })
      .catch((err) => {
        console.error(err)
        console.log(JSON.stringify(this.registerForm.errors))
      })
  },
}
export const computed = {
  /**
   * Determine if the selected country collects European VAT.
   */
  countryCollectsVat() {
    return this.collectsVat(this.registerForm.country)
  },

  /**
   * Get the displayable discount for the coupon.
   */
  discount() {
    if (this.coupon) {
      if (this.coupon.percent_off) {
        return this.coupon.percent_off + '%'
      } else {
        return Vue.filter('currency')(this.coupon.amount_off / 100)
      }
    }
  },

  /**
   * Get the current billing address from the register form.
   *
   * This used primarily for watching.
   */
  currentBillingAddress() {
    return (
      this.registerForm.address +
      this.registerForm.address_line_2 +
      this.registerForm.city +
      this.registerForm.state +
      this.registerForm.zip +
      this.registerForm.country +
      this.registerForm.vat_id
    )
  },
}
